
export enum ValueType {
  /** Number */
  number,
  /** Float */
  float,
  /** String */
  string,
  /** Boolean */
  boolean
}

export interface PropertySchema {
  /** Id */
  id?: number,
  /** PId */
  pId?: number,
  /** PId 路径 */
  parentPath?: string,
  /** 是否Group */
  isGroup?: boolean,
  /** 是否隐藏 */
  isHide?: boolean,
  /** 是否编辑 */
  isEdit?: boolean,
  /** 类型 */
  type?: string,
  /** 名称 */
  text: string,
  /** 属性唯一标识 */
  name: string,
  /** 值类型 */
  valueType: ValueType 
  /** 编辑参数 */
  editOption?: any,
  datas?: Array<any>,
  /** 说明 */
  summary?: string,
  /** 子节点 */
  children?: PropertySchema[],
  /** 展开子节点 */
  open?: boolean,
  tabIndex?: number,
  /** 值改变事件 */
  change?: Function,
  /** 按钮文本 */
  buttonText?: string,
  /** 按钮点击事件 */
  onButtonClick?: Function,
  /** 是否影像父元素伸展（布局组件专用）2021 04 14 msh */
  isStretch?:boolean,
  PropertySchema?:any
}
